import PopIn from './lib/popin.js';

const crtPopIn = document.querySelectorAll('[data-js-popin]');
[].forEach.call(crtPopIn, function(elem) {
  new PopIn(elem, "close");
});
